import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Loads Meta Pixel and TikTok Pixel scripts when:
 * 1. User has consented to marketing cookies
 * 2. Pixel IDs are configured in admin settings
 */
export default function TrackingPixels() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Check if user consented to marketing cookies
    const consent = localStorage.getItem("neuromap_cookie_consent");
    if (!consent) return;

    try {
      const parsed = JSON.parse(consent);
      if (!parsed.marketing) return;
    } catch {
      return;
    }

    // Fetch pixel IDs from backend
    const loadPixels = async () => {
      try {
        const res = await axios.get(`${API}/settings/tracking`);
        const { meta_pixel_id, tiktok_pixel_id } = res.data;

        if (meta_pixel_id && !document.getElementById("meta-pixel")) {
          const script = document.createElement("script");
          script.id = "meta-pixel";
          script.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${meta_pixel_id}');
            fbq('track', 'PageView');
          `;
          document.head.appendChild(script);
        }

        if (tiktok_pixel_id && !document.getElementById("tiktok-pixel")) {
          const script = document.createElement("script");
          script.id = "tiktok-pixel";
          script.innerHTML = `
            !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var i=document.createElement("script");i.type="text/javascript",i.async=!0,i.src=r+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(i,a)};
              ttq.load('${tiktok_pixel_id}');
              ttq.page();
            }(window, document, 'ttq');
          `;
          document.head.appendChild(script);
        }

        setLoaded(true);
      } catch {
        // Silently fail - pixels are non-critical
      }
    };

    loadPixels();
  }, []);

  return null; // No visible output
}
